import ApiHelper from "./ApiHelper";
import { jwtDecode } from "jwt-decode";
import Session from 'store2';
import * as apiURL from './ApiConfig';

class AuthServices {
  static async Login(body) {
    return ApiHelper.postAnonymous("login", body);
  }

  static async SignUp(body) {
    return ApiHelper.postAnonymous("signup", body);
  }

  static async ValidateToken(body) {
    return ApiHelper.getAuthenticated("validate-token", body);
  }

  static async VerifyOTP(body) {
    return ApiHelper.postAnonymousOTP("verify-otp", body);
  }

  static async VerifyPhone(body) {
    return ApiHelper.postAnonymousOTP("phone-verification", body);
  }

  static async SendOTP(body) {
    return ApiHelper.postAnonymousOTP("send-otp", body);
  }

  static async ValidateCaptcha(body) {
    return ApiHelper.postAnonymousOTP("validate-captcha", body);
  }

  static async ForgotPassword(body) {
    return ApiHelper.postAnonymous("forgot-password", body);
  }

  static async VerifyEmail(body) {
    return ApiHelper.postAnonymous("email-verification", body);
  }

  static async ResetPassword(body) {
    return ApiHelper.postAnonymous("change-password", body);
  }

  static async ConfirmEmail(body) {
    return ApiHelper.postAnonymous("confirm-email", body);
  }

  static async ContactUs(body) {
    return ApiHelper.postAnonymous("contact-us", body);
  }

  static async UploadProfileImage(body) {
    return ApiHelper.postAuthenticatedImage('professionals/upload-profile-image', body);
  }

  static async DownloadAttachment(body) {
    return ApiHelper.postAuthenticatedDownload("professionals/download-resume", body);
  }

  static async Generate2faSecret(body) {
    return ApiHelper.postAuthenticated("generate2faSecret", body);
  }

  static async Verify2faSecret(body) {
    return ApiHelper.postAuthenticated("verify2faSecret", body);
  }

  static async FindAddress(body) {
    return ApiHelper.postAuthenticated("find/address", body);
  }

  static async checkVpnProxy() {
    return ApiHelper.postAnonymousCheckVPN(apiURL.VPN_CONNECTION, '')
  }
  static GetCurrentLoggedUserDetails() {
    const userAccessToken = Session.session('token');
    if (userAccessToken) {
      return jwtDecode(userAccessToken.replace('Bearer ', ''));
    }
    return null;
  }
  static async PasswordPolicy(body) {
    return ApiHelper.postAnonymous("password-policy", body);
  }

}
export default AuthServices;
